<div class="card-block settings-general">
	<div class="card-title">
		<div class="card-title-label" translate>organization.card.manage-transactional-visibilities</div>
	</div>
	<ag-grid-angular class="copo-card-grid-container ag-theme-balham"
	[gridOptions]="gridInformationalVisibilities" (gridReady)="onGridReady($event)"
	(viewportChanged)="onViewportChanged($event)" [modules]="agGridModules">
	</ag-grid-angular>
</div>
